var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 51,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 19.375-4.252 4.252v-1.7H22.35v5.102l-2.994 2.994.583.583L30 20.575l10.043 10.042.582-.582zm-6.798 3.402h1.7v1.689l-1.7 1.701z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.351 30.425v10.2H28.3v-5.947h3.402v5.947h5.948v-10.2L30 22.777zm14.447 9.35h-4.252v-5.948h-5.097v5.948h-4.253v-9L30 23.977l6.798 6.798z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C13.431 60 0 46.569 0 30S13.431 0 30 0s30 13.431 30 30-13.431 30-30 30zm0-1.748c15.603 0 28.252-12.649 28.252-28.252S45.603 1.748 30 1.748 1.748 14.397 1.748 30 14.397 58.252 30 58.252z"
  })));
};
export default SvgHome;